import React, { useContext } from 'react';
import ThankYou from '../steps/ThankYou';
import LeaveReviewOnSolv from '../steps/ReviewOnSolvCollector';
import { ADD_REVIEW_FROM_DISCHARGE_EMAIL_DIRECT_TO_SOLV } from '../../../constants/index';
import { ReviewContext } from '~/routes/addReview/context';

type Props = {
  starRating?: number;
};

const ReviewOnSolv = (props: Props) => {
  const context = useContext(ReviewContext)!;

  const { booking, bookingId, flowState } = context;

  return (
    <div>
      <LeaveReviewOnSolv
        {...context}
        flowType={ADD_REVIEW_FROM_DISCHARGE_EMAIL_DIRECT_TO_SOLV}
        starRating={props.starRating}
      />

      <ThankYou
        booking={booking}
        bookingId={bookingId}
        flowState={flowState}
        starRating={props.starRating}
      />
    </div>
  );
};

export default ReviewOnSolv;
